export default {
	status: 200,
	data: {
		code: 200,
		data: {
			users: [
				{
					first_name: 'Anastasia',
					last_name: 'Homford',
					title: 'Dirigeant',
					agency: 'RE/MAX Platine',
					picture: 'https://via.placeholder.com/150',
					uuid: '9aa26375-27e8-3bcd-a8dd-d23209676052',
				},
				{
					first_name: 'Annie',
					last_name: 'Parent-Richard',
					title: 'Courtier',
					agency: 'RE/MAX Ambiance & Pro-Commerical',
					picture: 'https://via.placeholder.com/220',
					uuid: null,
				},
				{
					first_name: 'Antoine',
					last_name: 'Dumontier',
					title: 'Administrateur',
					agency: 'RE/MAX 3000',
					picture: 'https://via.placeholder.com/120',
					uuid: '685bfd4a-4138-48e4-9887-29f5d8702cfb',
				},
				{
					first_name: 'Archibald',
					last_name: 'Cunégonde',
					title: 'Administrateur',
					agency: 'RE/MAX Platine',
					picture: 'https://via.placeholder.com/200',
					uuid: 'z453460a-38cf-3756-b219-e4a4c0527022',
				},
				{
					first_name: 'John',
					last_name: 'Doe',
					title: 'Courtier',
					agency: 'RE/MAX 2000',
					picture: 'https://via.placeholder.com/200',
					uuid: 'e198460a-38cf-3756-b219-e4a4c0527022',
				},
				{
					first_name: 'Jane',
					last_name: 'Doe',
					title: 'Courtier',
					agency: 'RE/MAX 3000',
					picture: 'https://via.placeholder.com/200',
					uuid: 'b543460a-38cf-3756-b219-e4a4c0527022',
				},
			],
		},
	},
};
